<template>
  <div>
    <h1 class="page-header">Vendor Profile</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Name KH</label>
              <input
                v-model="model.vendor_name_kh"
                class="form-control"
                :class="{ 'is-invalid': errors.has('vendor_name_kh') }"
                placeholder="Enter name KH"
              />
              <div class="invalid-feedback" v-if="errors.has('vendor_name_kh')">
                {{ errors.first('vendor_name_kh') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Name EN <span class="text-danger">*</span></label>
              <input
                v-model="model.vendor_name_en"
                class="form-control"
                :class="{ 'is-invalid': errors.has('vendor_name_en') }"
                placeholder="Enter name EN"
              />
              <div class="invalid-feedback" v-if="errors.has('vendor_name_en')">
                {{ errors.first('vendor_name_en') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Contact No <span class="text-danger">*</span></label>
              <input
                v-model="model.contact_no"
                class="form-control"
                :class="{ 'is-invalid': errors.has('contact_no') }"
                placeholder="Enter contact number"
              />
              <div class="invalid-feedback" v-if="errors.has('contact_no')">
                {{ errors.first('contact_no') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Contact Person</label>
              <input
                v-model="model.contact_person"
                class="form-control"
                :class="{ 'is-invalid': errors.has('contact_person') }"
                placeholder="Enter contact person name"
              />
              <div class="invalid-feedback" v-if="errors.has('contact_person')">
                {{ errors.first('contact_person') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Email Address</label>
              <input
                v-model="model.email"
                class="form-control"
                :class="{ 'is-invalid': errors.has('email') }"
                placeholder="Enter email address"
              />
              <div class="invalid-feedback" v-if="errors.has('email')">
                {{ errors.first('email') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Website</label>
              <input
                v-model="model.website"
                class="form-control"
                :class="{ 'is-invalid': errors.has('website') }"
                placeholder="Enter website"
              />
              <div class="invalid-feedback" v-if="errors.has('website')">
                {{ errors.first('website') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="btn btn-default mr-2" @click.prevent="cancel">
                Cancel
              </ts-button>
              <ts-button v-if="updating" class="btn btn-primary" :waiting="waiting" @click.prevent="update">
                Update
              </ts-button>
              <ts-button v-if="!updating" class="btn btn-primary" :waiting="waiting" @click.prevent="store">
                Save
              </ts-button>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetchData" @fetched="fetchData = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import DataTable from './table.vue'
export default {
  name: 'vendor-profile-form',
  components: { DataTable },
  data() {
    return {
      model: {
        vendor_id: '',
        vendor_name_kh: '',
        vendor_name_en: '',
        contact_no: '',
        contact_person: '',
        email: '',
        website: ''
      },
      errors: new Errors(),
      updating: false,
      waiting: false,
      fetchData: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('administration/vendorProfile', ['companies', 'edit_data'])
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('administration/vendorProfile/store', Object.assign({}, this.model))
        .then(response => {
          this.fetchData = true
          this.waiting = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('administration/vendorProfile/update', Object.assign({}, this.model))
        .then(response => {
          this.fetchData = true
          this.waiting = false
          this.$toasted.success(response.message)
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    cancel() {
      this.fetchData = true
      this.updating = false
      this.$store.commit('administration/vendorProfile/SET_EDIT_DATA', {})
      this.$router.push({ name: 'vendor-profile' })
      this.clearInput()
    },

    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.updating = true
        this.model.vendor_id = this.edit_data.vendor_id
        this.model.vendor_name_kh = this.edit_data.vendor_name_kh
        this.model.vendor_name_en = this.edit_data.vendor_name_en
        this.model.contact_no = this.edit_data.contact_no
        this.model.contact_person = this.edit_data.contact_person
        this.model.email = this.edit_data.email
        this.model.website = this.edit_data.website
      }
    },
    clearInput() {
      this.model.vendor_i = ''
      this.model.company_id = ''
      this.model.vendor_name_kh = ''
      this.model.vendor_name_en = ''
      this.model.contact_no = ''
      this.model.contact_person = ''
      this.model.email = ''
      this.model.website = ''
    },
    clickBackURL() {
      this.$store.commit('administration/vendorProfile/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetchData = true
      this.updating = false
    }
  },
  watch: {
    edit_data: {
      handler() {
        if (!_.isEmpty(this.edit_data)) {
          this.setEditData()
        }
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('administration/vendorProfile/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
